module.exports = __webpack_public_path__ + "static/media/realise-500x500.b2c07012.png";